import React, {useEffect, useMemo, useState} from 'react';
import {Button, Collapse, FormControl, FormLabel, ListItemIcon, ListItemText, MenuItem} from '@mui/material';
import { withStyles } from "@mui/styles";

import DataTable from "../../../../util/data-table/DataTable";
import SelectedItemsToolbar from "./SelectedItemsToolbar";
import ItemsMap from "./ItemsMap";
import {
  AddFavoriteIcon,
  AddFolderIcon,
  AddItemIcon,
  AddJournalPostIcon,
  AddLinkIcon,
  AddUploadIcon, ImportIcon,
  LocationIcon,
  AddSurveyAttemptIcon
} from '../../../../../helpers/Icons'
import AddItemDialog from "../form/AddItemDialog";
import ItemViewDialog from "../item-viewer/ItemViewDialog";
import FileUploadDialog from "../../file-upload/FileUploadDialog";
import TagDialog from "../form/TagDialog";
import Menu from '@mui/material/Menu';
import {saveItem} from "../../../../../state/actions/updateDataActions";
import ConversionPoller from "./ConversionPoller";
import {setViewItem} from "../../../../../state/actions/getDataActions";
import {connect} from "react-redux";
import {ExpandLess} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import SurveySelectDialog from "../../surveys/menu/SurveySelectDialog";

const styles = {
  addButtonMain: {
    padding: '2px 10px 2px 6px',
    borderRadius: '19px',
    backgroundColor: '#ffffff',
    color: "rgba(38, 126, 166, 1)",
    border: "1px solid rgba(38, 126, 166, 0.5)",
    fontSize: '0.7225em',
    '& svg': {
      width: '24px',
      height: '24px',
      marginLeft: '4px',
    }
  },
  mapControls: {
    display: 'flex',
    marginTop: '1em',
    padding: '0',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    overflow: 'visible',
    position: 'relative',
    backgroundColor: '#ffffff'
  },
  mapLabel: {
    flexShrink: 0,
    fontSize: '0.85rem',
    marginTop:'-12px',
    position: 'absolute',
    backgroundColor: 'inherit',
    borderRadius: '4px',
    zIndex: 10,
    border: '1px solid rgba(0, 0, 0, 0)',
    '&> button':{
      // textTransform: 'none',
      padding: '0px 4px',
      fontWeight: 500,
      fontSize: '0.85em',
      zIndex: 10,
      color: 'rgba(0, 0, 0, 0.87)'
    },
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      // backgroundColor: '#f5f5f5',
    },
    marginLeft: '1em'
  },
};

function updateViewAndTagItems(prev, newItem){
  if(!prev || !newItem || prev.id !== newItem.id){
    return null;
  }
  if(newItem.url_ts !== prev.url_ts){
    return newItem;
  }
  return null;
}
function loadViewItem(mindfileId, viewItemId, itemMap, getMindfileItem, updateItemViewCount, callback=()=>{}){
  if(!viewItemId){
    if(callback){
      callback(null)
    }
    return null;
  }
  let vItem = itemMap[viewItemId];
  if(vItem){
    updateItemViewCount(mindfileId, viewItemId);
    if(callback){
      callback(vItem);
    }
  }else{
    Promise.allSettled([
      getMindfileItem(mindfileId, viewItemId, true, (item) => {
        vItem = item;
        if (callback) {
          callback(item);
        }
        return item;
      }, false)
    ]).catch(err => console.error(err));
  }
  return vItem;
}
function ItemsPage(props) {
  const {
    title, mindfileId, mindfileUserLevel, getMindfileItem, viewItem, setViewItem,
    fetchItems, itemList, itemCount, saveItem,
    controller, setController, mapBounds, getMindfileItemLocations,
    disableMap, filters, filterSelections, mindfileFilterValues, addFilterSelectByName,
    selectedIds, selectedItems, setSelectedItems,
    getMindfileItemsDetails, updateItemViewCount,
    removeItems, moveItems, folderList, addFolder,
    columns, addButtons, topPanel:TopPanel, topPanelProps, addItemProps,

    visibleColumns, clearFilterSelections,
    bindViewOptions, loading, setLoading, viewOptsLoaded, setMapBounds,
    viewMode, setViewMode, viewModeOptions,
    iconSize, setIconSize, iconSizeOptions,
    filtersOpen, setFiltersOpen, columnsOpen, setColumnsOpen, setVisibleColumns,
    setSelectedIds, displayCurrentMindfile, classes } = props;
  const viewingLevel = typeof(props.viewingLevel) === "number" ? props.viewingLevel : mindfileUserLevel;
  const userLevel = props.forceViewingLevel ? props.viewingLevel : mindfileUserLevel;
  const [mapOpen, setMapOpen] = useState(false);
  const [addItemState, setAddItemState] = useState({
    type:'Link',
    open: false
  });

  const [isUploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [isSurveySelectDialogOpen, setSurveySelectDialogOpen] = useState(false);
  const [isViewItemDialogOpen, setViewItemDialogOpen] = useState(false);

  const [tagOpen, setTagOpen] = useState(false);
  const [savingInProgress, setSavingInProgress] = useState(false);
  const [tagItems, setTagItems] = useState([]);

  const columnMap = useMemo(() => Object.fromEntries(columns.map(col => [col.key,col])), [columns]);

  const [itemMap, setItemMap] = useState(Object.fromEntries(itemList.map((item) => [item.id, item])));
  useEffect(() => {
    const newMap = Object.fromEntries(itemList.map((item) => [item.id, item]));
    setItemMap(newMap);
  }, [itemList])

  useEffect(() => {
    if (viewingLevel > 2) {
      if (columns[0].key === "selected") {
        columns[0].enabled = false;
      }
      if (filters[0].key === "status") {
        filters[0].visible = false;
        filterSelections[0].selectedItems = [1];
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewingLevel]);

  const updateItems = (getNewItems) => {
    if(tagItems && tagItems.length > 0) {
      const newTags = getNewItems(tagItems);
      if (newTags !== null) {
        setTagItems(newTags)
      }
    }
  };

  const handlePageChange = (event, page) => {
    let maxPage = Math.max(1, !itemCount ? page : Math.ceil(itemCount / controller.rowsPerPage));
    let newPage = Math.min(Math.max(1, page), maxPage);
    if(newPage === controller.page){
      return;
    }
    setController((prevState, props) =>({
      ...prevState.controller,
      page: newPage
    }));
    // setSelectedIds([]);
  };

  const afterItemsChange = (ids) => {
    let maxPage = Math.max(1, !itemCount ? controller.page : Math.ceil((itemCount - ids.length) / controller.rowsPerPage));
    if(controller.page > maxPage){
      handlePageChange(null, maxPage);
    }else{
      // setSelectedIds([]);
      fetchItems(mapOpen);
    }
  };

  const handleDeleteSelected = () => {
    const ids = Object.entries(selectedItems).map(e => e[1].id);
    // console.log(selectedItems, ids);
    setSavingInProgress(true);
    removeItems(ids, () => {
      afterItemsChange(ids);
      setSavingInProgress(false);
    });
  };

  const handleMoveSelected = (folderId) => {
    const ids = Object.entries(selectedItems).map(e => e[1].id);
    setSavingInProgress(true);
    moveItems(ids, folderId, () => {
      afterItemsChange(ids);
      setSavingInProgress(false);
    });
  };

  const handleTagSelected = () => {
    const items = Object.entries(selectedItems).map(e => e[1]);
    handleTagItems(items);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const renderAddToolbar = () => {
    if(!addButtons || addButtons.length === 0){
      return null;
    }
    if(addButtons.length > 1){
      return renderAddItemsMenu();
    }else{
      return renderAddItemSingle();
    }
  };

  const renderAddItemSingle = () => {
    return <>
      {addButtons.map((button) => {
        if(button === "Upload"){
          return (renderAddButton("Upload", "Upload Files"));
        }else if (button === "Link") {
          return (renderAddButton("Link", "Add Link"));
        }else if (button === "Favorite") {
          return (renderAddButton("Favorite", "Add Favorite"));
        }else if (button === "JournalPost") {
          return (renderAddButton("JournalPost", "Add Journal Post"));
        }else if (button === "SurveyAttempt") {
          return (renderAddButton("SurveyAttempt", "Start Profile Assessment"));
        }else if (button === "Folder") {
          return (renderAddButton("Folder", "Add Folder"));
        }
        return null;
      })}
    </>
  };

  const renderAddButton = (type, label) => {
    return <Button
        id="addButtonMain"
        key={type}
        size="large"
        onClick={openAddItemDialog.bind(this, type)}
        className={classes.addButtonMain}
        startIcon={itemAddIcons[type]}
        variant="outlined" color="primary"
      >
        { label || type }
      </Button>
  };

  const renderAddItemsMenu = () => {
    return <>
      <Button
        id="addButtonMain"
        size="large"
        onClick={handleClick}
        className={classes.addButtonMain}
        startIcon={<AddItemIcon />}
        variant="outlined" color="primary"
        aria-controls={open ? 'add-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        Add Item
      </Button>
      <Menu
        id="add-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button', 'id': 'add-options'
        }}
      >
        {addButtons.map((button) => {
          if(button === "Upload"){
            return (renderAddMenuButton("Upload", "Upload Files"));
          }else if (button === "Link") {
            return (renderAddMenuButton("Link", "Add Link"));
          }else if (button === "Favorite") {
            return (renderAddMenuButton("Favorite", "Add Favorite"));
          }else if (button === "JournalPost") {
            return (renderAddMenuButton("JournalPost", "Add Journal Post"));
          }else if (button === "SurveyAttempt") {
            return (renderAddMenuButton("SurveyAttempt", "Start Profile Assessment"));
          }else if (button === "Folder") {
            return (renderAddMenuButton("Folder", "Add Folder"));
          }else if (button === "Import") {
            return (renderAddMenuButton("Import", "Import Items"));
          }
          return null;
        })}
      </Menu>
    </>
  };
  const history = useHistory();
  const renderAddMenuButton = (type, label) => {
    return <MenuItem key={type}
        onClick={() => {
          handleClose();
          if(type === "Import"){
            history.push("/explore/imports")
          }else {
            openAddItemDialog(type);
          }
        }}
      >
        <ListItemIcon size="small" style={{color: '#267ea6', minWidth:'24px', marginRight: '0.5em'}}>{itemAddIcons[type]}</ListItemIcon>
        <ListItemText>{ label || type }</ListItemText>
      </MenuItem>
  };

  const itemAddIcons = {
    'Upload': <AddUploadIcon />,
    'Link': <AddLinkIcon />,
    'Favorite': <AddFavoriteIcon />,
    'JournalPost': <AddJournalPostIcon />,
    'SurveyAttempt': <AddSurveyAttemptIcon />,
    'Folder': <AddFolderIcon />,
    'Import': <ImportIcon />,
  };

  const openAddItemDialog = (itemType, e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    if(itemType === 'Upload'){
      setUploadDialogOpen(true);
    }else if(itemType === 'SurveyAttempt'){
      setSurveySelectDialogOpen(true);
    }else{
      setAddItemState({type: itemType, open: true});
    }
  };

  const openItemViewDialog = (itemId, e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    loadViewItem(mindfileId, itemId, itemMap, getMindfileItem, updateItemViewCount, item => {
      if(!item){
        return;
      }
      if(item && item.status === "pending" && viewingLevel <= 2){
        handleTagItems([item]);
      }else {
        setViewItem(item);
        setViewItemDialogOpen(true)
      }
    })
  };

  const closeItemViewDialog = (e) => {
    if(e){
      e.preventDefault();
      e.stopPropagation();
    }
    setViewItemDialogOpen(false);
    setViewItem(null);
  };

  const handleMapOpen = (open) => {
    setMapOpen(open);
    if(!open) {
      props.setMapBounds((prevState, props) => null);
    }
  }

  const getItemMap = () => disableMap ? [] : [
    {
      button: {
        key: 'mapOpen',
        action: () => handleMapOpen(!mapOpen),
        label: <>Map</>,
        startIcon: <LocationIcon />,
        open: mapOpen
      },
      panel: (
        <Collapse key='map' in={mapOpen} timeout="auto" unmountOnExit>
          <FormControl id='dataMap' className={classes.mapControls}>
            <FormLabel className={classes.mapLabel} component="div">
              <Button onClick={() => handleMapOpen(!mapOpen)}>Map<ExpandLess size="small" variant="outlined" style={{fontSize: '1rem'}} /></Button>
            </FormLabel>
            <ItemsMap
              mapOpen={mapOpen}
              mindfileId={mindfileId}
              isDialogOpen={isViewItemDialogOpen || isUploadDialogOpen || isSurveySelectDialogOpen || tagOpen || addItemState.open}
              openItemViewDialog={openItemViewDialog}
              getMindfileItemLocations={getMindfileItemLocations}
              itemList={itemList}
              itemMap={itemMap}
              selectedIds={selectedIds}
              mapBounds={mapBounds}
              setMapBounds={(bounds) => props.setMapBounds((prevState, props) => (bounds))}
              controller={controller}
              filters={filters}
              filterSelections={filterSelections}
            />
          </FormControl>
        </Collapse>
      )
    }
  ];

  const handleTagItems = (targetItems) => {
    setTagItems(targetItems);
    setTagOpen(targetItems.length > 0)
    // setSavingInProgress(false);
  };

  const doSaveItems = (items, itemCallback, allStartedCallback, allFinishedCallback) => {
    setSavingInProgress(true);
    itemCallback = itemCallback ? itemCallback : () => {};
    allFinishedCallback = allFinishedCallback ? allFinishedCallback : () => {};
    let count = items.length;
    Promise.all(items.map(item => saveItem(item, (saved) => {
      try {
        itemCallback(saved);
      }catch (e) {
        console.error("callback error", e);
      }
      count--;
      if(count === 0){
        allFinishedCallback();
        setSavingInProgress(false);
      }
    })))
    .catch(e => console.error(e))
    .then(allStartedCallback);
  };

  useEffect(() => {
      updateItems((prevItems) => {
        let changed = false;
        const newItems = [...prevItems];
        itemList.forEach(newItem => {
          let i = prevItems.findIndex(item => !!item && item.id === newItem.id);
          if(i === -1){
            return;
          }
          const prev = prevItems[i];
          const updated = updateViewAndTagItems(prev, newItem);
          if(updated){
            newItems[i] = updated;
            changed = true;
          }
        })
        return changed ? newItems : null;
      })
    },
    // eslint-disable-next-line
    [itemList]
  );

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value);
    let itemFirst = Math.max(0, ((controller.page - 1) * controller.rowsPerPage) + 1);
    if(!!itemCount){
      itemFirst = Math.min(itemCount, itemFirst);
    }
    const page = Math.floor(itemFirst / newRows) + 1;
    let maxPage = Math.max(1, !itemCount ? page : Math.ceil(itemCount /newRows));
    let newPage = Math.min(Math.max(1, page), maxPage);
    setController((prevState, props) => ({
      ...prevState.controller,
      rowsPerPage: newRows,
      page: newPage
    }));
  };

  return (
    <>
      <div style={{position:'relative', display: 'flex', flexDirection:'row', flexWrap:'wrap-reverse', alignItems: 'center', margin: '0 0 1rem', gap: '1em'}}>
        { viewingLevel <= 2 ?
          <div style={{flexGrow:0, flexShrink:0, whiteSpace: 'nowrap', marginRight:'1em'}}>
            {renderAddToolbar()}
          </div>
          : <div style={{flexGrow:146, flexShrink:1, maxWidth: '162px', minWidth:'0px'}}></div>
        }
        <div style={{flexGrow:1}}>
          <h2 id="pageTitle" style={{textAlign: 'center', fontWeight: '400', wordBreak:'break-word', margin: '0 auto'}}>{title}</h2>
        </div>
        {!addButtons || addButtons.length === 0 ? null : <div style={{flexGrow:146, flexShrink:1, maxWidth: '162px', minWidth:'0px'}}></div>}
      </div>
      {!TopPanel ? null : <TopPanel
        openDataView={openItemViewDialog}
        {...topPanelProps}
      />}
      <DataTable
        itemList={itemList}
        itemMap={itemMap}
        itemCount={itemCount}
        openDataView={openItemViewDialog}
        tableToolbar={getItemMap()}
        saveItems={(items) => doSaveItems(items, () => {}, () => {}, () => afterItemsChange(items.map(item => item.id)))}
        removeItems={(ids) => removeItems(ids, () => afterItemsChange(ids))}
        moveItems={(ids, folderId) => moveItems(ids, folderId, () => afterItemsChange(ids))}
        mindfileUserLevel={viewingLevel}
        selectedItems={viewingLevel > 2 ? {} : selectedItems}
        setSelectedItems={viewingLevel > 2 ? null : setSelectedItems}
        mindfileId={mindfileId}
        bindViewOptions={bindViewOptions}
        fetchItems={fetchItems}
        folderList={folderList}
        addFolder={addFolder}
        columns={columns}
        columnMap={columnMap}
        visibleColumns={visibleColumns}
        filters={filters}
        filterSelections={filterSelections}
        addFilterSelectByName={addFilterSelectByName}
        clearFilterSelections={clearFilterSelections}
        mindfileFilterValues={mindfileFilterValues}
        controller={controller}
        setController={setController}
        mapBounds={mapBounds}
        setMapBounds={setMapBounds}
        loading={loading || savingInProgress}
        setLoading={setLoading}
        viewOptsLoaded={viewOptsLoaded}

        viewMode={viewMode}
        setViewMode={setViewMode}
        viewModeOptions={viewModeOptions}
        iconSize={iconSize}
        setIconSize={setIconSize}
        iconSizeOptions={iconSizeOptions}
        filtersOpen={filtersOpen}
        setFiltersOpen={setFiltersOpen}
        columnsOpen={columnsOpen}
        setColumnsOpen={setColumnsOpen}
        setVisibleColumns={setVisibleColumns}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
        
        
        selectedToolbar={(
          <SelectedItemsToolbar
            pageItemCount={itemList.length}
            selectedItems={selectedItems}
            folderList={folderList}
            addFolder={addFolder}
            handleMoveSelected={handleMoveSelected}
            handleDeleteSelected={() => {
              setSavingInProgress(true);
              handleDeleteSelected();
            }}
            handleTagSelected={handleTagSelected}
            controller={controller}
            itemCount={itemCount}
            handlePageChange={handlePageChange}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            mindfileUserLevel={viewingLevel}
          />
        )}
        getMindfileItem={getMindfileItem}
        mindfileDisplay={displayCurrentMindfile ? [props.mindfile?.name, props.mindfile?.timestamp] : null}
        primaryMindfile={props.primaryMindfile}
      />
      <ConversionPoller
        mindfileId={mindfileId}
        itemList={itemList}
        itemExtra={viewItem}
        getMindfileItemsDetails={getMindfileItemsDetails}
        updateItems={updateItems}
      />
      {viewItem ?
        <ItemViewDialog
          id="itemViewDialog"
          item={viewItem}
          setItem={setViewItem}
          columnMap={columnMap}
          mindfileUserLevel={userLevel}
          canSelect={false}
          showToolbar={userLevel <= 2}
          showStatusIcon={true}
          isOpen={isViewItemDialogOpen}
          openDataView={openItemViewDialog}
          closeDialog={closeItemViewDialog}
          folderList={folderList}
          addFolder={addFolder}
          addFilterSelectByName={addFilterSelectByName}
          mindfileFilterValues={mindfileFilterValues}
          handleCancel={closeItemViewDialog}
          itemChangeCallback={fetchItems}
          saveItems={(items) => doSaveItems(items, () => {}, () => {}, () => {
            afterItemsChange(items.map(item => item.id));
            // closeItemViewDialog();
          })}
          removeItems={(ids) => removeItems(ids, () => {
            afterItemsChange(ids);
            closeItemViewDialog();
          })}
          moveItems={(ids, folderId) => moveItems(ids, folderId, () => {
            afterItemsChange(ids);
            // closeItemViewDialog();
          })}
          title={`View ${viewItem.name}`}
          getMindfileItem={getMindfileItem}
          mindfileDisplay={displayCurrentMindfile ? [props.mindfile?.name, props.mindfile?.timestamp] : null}
        /> : null }
      {addItemState.open ?
        <AddItemDialog
          isOpen={addItemState.open}
          closeDialog={() => setAddItemState({...addItemState, open: false})}
          itemChangeCallback={fetchItems}
          itemType={addItemState.type}
          folderList={folderList}
          addFolder={addFolder}
          mindfileFilterValues={mindfileFilterValues}
          addItemProps={addItemProps}
        />
        : null
      }
      {isSurveySelectDialogOpen ?
        <SurveySelectDialog
          isOpen={isSurveySelectDialogOpen}
          itemChangeCallback={fetchItems}
          openDataView={openItemViewDialog}
          filterName={addFilterSelectByName.bind(this, 'Assessment')}
          closeDialog={() => setSurveySelectDialogOpen(false)}
          folderList={folderList}
          addFolder={addFolder}
        />
        : null
      }
      {!folderList || folderList.length === 0 ? null :
        <>
          <FileUploadDialog
            isOpen={isUploadDialogOpen}
            closeDialog={() => setUploadDialogOpen(false)}
            itemChangeCallback={fetchItems}
            folderList={folderList}
            addFolder={addFolder}
            mindfileFilterValues={mindfileFilterValues}
            afterItemsChange={afterItemsChange.bind(this,[])}
            savingInProgress={savingInProgress}
            setSavingInProgress={setSavingInProgress}
            addItemProps={addItemProps}
            saveItems={(items, itemCallback, allStarted, allCallback) => doSaveItems(items, itemCallback, allStarted, allCallback)}
          />
          <TagDialog
            mindfileUserLevel={mindfileUserLevel}
            id="tagSelected"
            authenticityToken={props.authenticityToken}
            open={tagOpen}
            items={tagItems}
            folderList={folderList}
            addFolder={addFolder}
            mindfileFilterValues={mindfileFilterValues}
            closeDialog={setTagOpen.bind(this, false)}
            afterItemsChange={afterItemsChange.bind(this,[])}
            savingInProgress={savingInProgress}
            saveItems={(items, allStarted, allComplete) => doSaveItems(items, () => {}, allStarted, allComplete)}
          />
        </>
      }
    </>
  );
}

const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    viewItem: state.viewItem,
    user: state.auth,
    // mindfileUserLevel: 3,
    // isAdmin: false,
    // isCurrentMindfileOwner: false,
    // isCurrentMindfileContributor: false,
    mindfileUserLevel: state.mindfileUserLevel.level,
    mindfileUserAdmin: state.mindfileUserLevel.admin,
    // isAdmin: state.auth.is_admin,
    primaryMindfile: state.auth.mid === state.mindfile.id,
    // isCurrentMindfileContributor: state.isCurrentMindfileContributor || state.isCurrentMindfileOwner || state.auth.is_admin ,
  };
}

const mapDispatchToProps = {
  setViewItem,
  saveItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ItemsPage));
